import api from "../services/apiList";
import { emptyError, ResponseType } from "../Types/ServicesType/servicesType";
import {
  InsurancePlanType,
  InsuranceReceiverType,
  InsuranceTypesType,
  PostOfficeType,
  ProirApprovalSearchFilterType,
  ProirApprovalSearchType,
} from "./types";
import { AuditLogResponseType } from "./AuditLog/types";
import {
  ClaimDownloadParams,
  ClaimSubmissionParams,
  SubmitResponseType,
} from "./ClaimListing/types";
import {
  PriorApprovalDownloadType,
  PriorApprovalPateintSearchParams,
  PriorApprovalPatientResponseType,
  PriorSearchParamsType,
  SearchResponseType,
} from "./PriorApprovalDashboard/types";
import { uploadPayloadType } from "./Verification/Types/PayloadType";
import instance from "@services/services";
import { getConstants } from "@utilifiles/methods/storage/storage";
const { clinicId } = getConstants();

const { insuranceApi, patientEncounterApi } = api;

export const proirApprovalSearch = async (
  params: Omit<ProirApprovalSearchType, "clinicId">
): Promise<ResponseType<any>> => {
  const body: ProirApprovalSearchType = {
    ...params,
    clinicId,
  };
  try {
    const result = await instance.post(insuranceApi.listPriorApprovals, body);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const verificationList = async (
  params: any
): Promise<ResponseType<any>> => {
  const body: any = {
    ...params,
    clinicId,
  };
  try {
    const result = await instance.post(insuranceApi.verificationList, body);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getClaimListTableData = async (
  params: any
): Promise<ResponseType<any[] | null>> => {
  const body = {
    ...params,
    clinicId,
  };
  try {
    return (await instance.post(insuranceApi.claimListTableData, body)).data;
  } catch (error) {
    return { ...emptyError, response: [] };
  }
};

export const downloadPriorApproval = async (): Promise<
  ResponseType<PriorApprovalDownloadType[] | null>
> => {
  try {
    return (
      await instance.get(`${insuranceApi.downloadPriorApproval}${clinicId}`)
    ).data;
  } catch (error) {
    return emptyError;
  }
};

export const submitClaims = async (
  params: Omit<ClaimSubmissionParams, "clinicId">
): Promise<ResponseType<SubmitResponseType[]>> => {
  const body = {
    ...params,
    clinicId,
  };
  try {
    return (await instance.post(insuranceApi.claimSubmission, body)).data;
  } catch (error) {
    return { ...emptyError, response: [] };
  }
};

export const downloadClaims = async (
  params: Omit<ClaimDownloadParams, "clinicId">
): Promise<ResponseType<any>> => {
  const body = {
    ...params,
    clinicId,
  };
  try {
    return (await instance.post(insuranceApi.claimDownload, body)).data;
  } catch (error) {
    return { ...emptyError, response: [] };
  }
};

export const searchPriorApprovals = async (
  data: Omit<ProirApprovalSearchFilterType, "clinicId">
): Promise<ResponseType<SearchResponseType>> => {
  try {
    return (await instance.post(insuranceApi.searchPriorApproval, data)).data;
  } catch (error) {
    return {
      ...emptyError,
      response: {
        items: [],
        totalCount: 0,
        responseMessage:""
      },
    };
  }
};

export const findPriorApprovals = async (
  data: Omit<PriorSearchParamsType, "clinicId">
): Promise<ResponseType<SearchResponseType>> => {
  const body = {
    ...data,
    clinicId,
  };
  return (await instance.post(insuranceApi.findPriorApprovals, body)).data;
};

export const getallStatus = async (): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(
      `${insuranceApi.getAllStatus}/${clinicId}`
    );
    return result.data;
  } catch {
    return emptyError;
  }
};

// export const getRadioDetails = async (encounterId:number):Promise<RadiologyDetailsType[]|[]>=>{
//   const body = {
//     queryParams: {
//       filter: {
//         status: 1
//       },
//       sortOrder: "asc",
//       sortField: "",
//       pageNumber: 0,
//       pageSize: 20,
//       clinicId: 1
//     },
//     encounterID: encounterId
//   };

//   try {
//     const result = await instance.post(`${insuranceApi.getRadiology}`,body)
//       console.log(result);

//     return result.data

//   } catch (error) {
//      return []
//   }
// }

export const getAllVitals = async (
  encounterId: number
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(
      `${insuranceApi.getVitals}${encounterId}?clinicId=${clinicId}`
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getComPlaints = async (
  encounterId: number
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(
      `${insuranceApi.getComplaints}${encounterId}?clinicId=${clinicId}`
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getActivityData = async ({
  encounterId,
  page = null,
}: {
  encounterId: number;
  page?: string | null;
}): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(
      `${insuranceApi.getActivity}${encounterId}?clinicId=${clinicId}&cptGroupId=0&page=${page}`
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const UpdateClaimStatus = async (
  data: any
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.put(
      `${insuranceApi.updateStatusOfClaim}`,
      data
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getAuditLog = async (
  id: string
): Promise<ResponseType<AuditLogResponseType[] | null>> => {
  try {
    const response = (
      await instance.get(`${insuranceApi.auditLog}${id}?clinicId=${clinicId}`)
    ).data;
    return response;
  } catch (error) {
    return emptyError;
  }
};

export const getPriorApprovalsPatients = async (
  params: PriorApprovalPateintSearchParams
): Promise<ResponseType<PriorApprovalPatientResponseType | null>> => {
  const body = {
    ...params,
    clinicId,
  };

  try {
    const response = (
      await instance.post(`${insuranceApi.priorApprovalsPatientSearch}`, body)
    ).data;
    return response;
  } catch (error) {
    return emptyError;
  }
};

export const uploadDocuments = async ({
  body,
  file,
}: {
  body: uploadPayloadType;
  file: File;
}): Promise<ResponseType<PriorApprovalPatientResponseType | null>> => {
  const formdata: FormData = new FormData();
  formdata.append("data", JSON.stringify(body));
  formdata.append("file", file);

  try {
    const response = await instance.post(
      `${api.insuranceApi.uploadFile}`,
      formdata,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error uploading documents:", error);
    return emptyError;
  }
};

export const viewdocuments = async (params: {
  requestId: number;
  encounterId: number;
  cptGrpId: number;
  postOfficeId: number;
}): Promise<ResponseType<string | Blob>> => {
  return (await instance.post(insuranceApi.getUploadedDocument, params)).data;
};

export const getPostOffice =async ():Promise<ResponseType<PostOfficeType[]>> => {
     const result = await instance.get(`${patientEncounterApi.postOfficeApi}${clinicId}`)
    return result.data
};


export const getObeservtaions = async (data: any) => {
  try {
    const result = await instance.post(insuranceApi.getAllDocuments, data);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};
export const deleteObeservtaions = async (data: any) => {
  try {
    const result = await instance.post(insuranceApi.deleteDocument, data);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getInsuranceType = async ():Promise<ResponseType<InsuranceTypesType[]>> => {
  const result = await instance.get(`${patientEncounterApi.getallinsType}${clinicId}`);
  return result.data;
};

export const getInsuranceByParams = async ({typeId}:{typeId: number}):Promise<ResponseType<InsuranceReceiverType[]>> => {
  console.log(typeId,"getInsuranceByParams called")
  const body = {
    searchText: null,
    typeId,
    clinicId,
  };
  const result = await instance.post(`${patientEncounterApi.getInsByTpe}`, body)
  console.log(result,"getInsuranceByParams result")
  
  return result.data;
};

export const getInsuracePlan = async (params:{clinicId:number,insType:number,insName:number,insGroup?:number}):Promise<ResponseType<InsurancePlanType[]>> => {
  const result = await instance.post(patientEncounterApi.getInsPlan,params);
  return result.data;
};
